module.exports = __webpack_public_path__ + "img/image81.c3e294da.jpg";